import type { ChatRoomItemsInterface } from '../../components/chat/ChatRoom';

export const addMessageIfMissing = (
	messages: ChatRoomItemsInterface[],
	message: ChatRoomItemsInterface
): ChatRoomItemsInterface[] => {
	const existingIndex = messages.findIndex((currentMessage) => currentMessage.id === message.id);
	if (existingIndex === -1) {
		return [message, ...messages];
	}

	return messages.map((currentMessage) => (currentMessage.id === message.id ? message : currentMessage));
};

export const applySeenMessages = (
	messages: ChatRoomItemsInterface[],
	updates: ChatRoomItemsInterface[]
): ChatRoomItemsInterface[] => {
	const updatesById = new Map(updates.map((message) => [message.id, message]));
	return messages.map((message) => updatesById.get(message.id) ?? message);
};

export const removeMessageById = (messages: ChatRoomItemsInterface[], messageId: number | string) =>
	messages.filter((message) => `${message.id}` !== `${messageId}`);
